import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {

  @Input() panelOpenState: boolean;
  @Input() expanded: boolean = true;

  @Input() contentObjAccordion: any;

  @Input() maxHeight: number;

}
